const APP_POPOUT_SIZE = { width: 360, height: 680 };
const APP_DEVICE_TYPE = {
  mobile: 'mobile',
  desktop: 'desktop'
};
const APP_CAPABILITIES = [
  //APIs
  'getMeetingContext',
  'getUserContext',
  'getMeetingJoinUrl',
  'getMeetingUUID',
  'openUrl',
  'makePhoneCall'
  //"getMeetingParticipants",
  //Events
  //"onParticipantChange"
];

const DIRECTORY_APP_CAPABILITIES = ['openUrl'];

const MAKEPHONECALL_SUCCESS = 'Success';
const MAKEPHONECALL_FAILURE = 'Failure';

export { APP_POPOUT_SIZE, APP_CAPABILITIES, APP_DEVICE_TYPE, DIRECTORY_APP_CAPABILITIES, MAKEPHONECALL_SUCCESS, MAKEPHONECALL_FAILURE };
